/**
 * Vmesnik do trajne shrambe (T2 §10).
 *
 * Zakaj vmesnik in ne neposreden `localStorage`: sinhronizacija v v1.1 je
 * zasnovana kot **dodaten ponudnik**, ne predelava. Poleg tega je zgodovina
 * v fazi 5 v IndexedDB, ki je asinhrona — če bi bil vmesnik sinhron, bi jo
 * bilo treba pozneje razbiti.
 *
 * Domena vmesnika ne pozna: dela s `Station`, ne s tem, kaj je v shrambi
 * (T2 §1, načelo 1).
 */

/**
 * Ključi so ločeni po domeni (T2 §1, načelo 3). Vse v enem ključu pomeni,
 * da vsak zapis serializira celoto — in da en pokvarjen del pokvari vse.
 */
export const STORAGE_KEYS = ['stations', 'settings', 'stats', 'sleep'] as const;
export type StorageKey = (typeof STORAGE_KEYS)[number];

/** Predpona vseh ključev; `nw.` je kratka in ne trči z DS ali ničemer drugim. */
export const KEY_PREFIX = 'nw.';

/** Ključ verzije sheme. Ni `StorageKey` — ni domenski podatek, ampak meta. */
export const VERSION_KEY = `${KEY_PREFIX}v`;

export function storageKeyName(key: StorageKey): string {
  return `${KEY_PREFIX}${key}`;
}

export interface StoragePort {
  load<T>(key: StorageKey): Promise<T | null>;
  save<T>(key: StorageKey, value: T): Promise<void>;
  clear(key: StorageKey): Promise<void>;

  /** Verzija sheme v shrambi; `null`, kadar shramba še ni bila zapisana. */
  readVersion(): Promise<number | null>;
  writeVersion(version: number): Promise<void>;

  /**
   * Varnostna kopija pred migracijo (T2 §4, pravilo 3). Ločena od `save`,
   * ker ne gre skozi `StorageKey` in je ne sme prepisati noben domenski zapis.
   */
  backup(version: number, snapshot: unknown): Promise<void>;
}
